import gql from "graphql-tag";

export default gql`
  mutation deleteSource($sourceId: ID, $customerId: ID) {
    deleteSource(sourceId: $sourceId, customerId: $customerId) {
      id
      description
    }
  }
`;

export const deleteSourceFromDeploymentMutation = gql`
  mutation deleteSourceFromDeployment($sourceId: ID, $customerId: ID, $deploymentId: ID) {
    deleteSourceFromDeployment(sourceId: $sourceId, customerId: $customerId, deploymentId: $deploymentId) {
      id
      description
    }
  }
`;
